<template>
    <v-card class="mx-auto" outlined :dark="isDark" :min-width="cardMinWidth" :max-width="cardMaxWidth"
        :min-height="cardMinHeight" :color="cardColor" elevation="4" :tile="true">
        <v-container>
            <v-row>
                <v-col v-if="cardShowTitle">
                    <slot name="crdTitle">
                        <v-list-item-title class="text-h6 mb-4 tertiary--text">
                            {{ cardTitle }}
                        </v-list-item-title>
                    </slot>
                </v-col>
                <v-col v-if="cardShowSubHeader">
                    <slot name="crdSubHeader">
                        <!-- connected to props so you can change it -->
                        <div class="text-overline mb-4 tertiary--text">
                            {{ cardSubHeaderText }}
                        </div>
                    </slot>
                </v-col>
            </v-row>
            <slot :name="cardAutomatic" v-if="!cardShowAutomatic">
                <v-row no-gutters>
                    <v-col cols="1" xs="0" sm="0" md="1" class="flex-grow-0 flex-shrink-0"></v-col>
                    <v-col cols="10" xs="0" sm="0" md="10" class="flex-grow-0 flex-shrink-0">
                        <br>
                        <v-row justify="center" no-gutters>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Fecha
                                        Inicio:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{
                                        initDate
                                        }}</v-list-item-title>
                                </v-row>
                            </v-col>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Precio
                                        Actual:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ currentPrice
                                        }}</v-list-item-title>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br>
                        <vDivider></vDivider>
                        <br>
                        <v-row justify="center" no-gutters>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Saldo
                                        Bot:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ available
                                    }}</v-list-item-title>
                                </v-row>
                            </v-col>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Saldo (
                                        {{ pair1 }} ) :</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ market1
                                    }}</v-list-item-title>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br>
                        <vDivider></vDivider>
                        <br>
                        <v-row justify="center" no-gutters>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Beneficios:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{
                                        profits
                                        }}</v-list-item-title>
                                </v-row>
                            </v-col>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Comisiones:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ fees
                                        }}</v-list-item-title>
                                </v-row>

                            </v-col>
                        </v-row>
                        <br>
                        <vDivider></vDivider>
                        <br>
                        <v-row v-show="isActive" no-gutters>
                            <v-col cols="4" xs="0" sm="0" md="4" class="flex-grow-0 flex-shrink-0"></v-col>
                            <v-col cols="4" xs="12" sm="12" md="4" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-card>
                                        <v-btn :color="colors" @click="statusBot">{{
                                            msgBtn }}</v-btn>
                                    </v-card>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br>
                    </v-col>
                </v-row>
            </slot>
            <slot :name="cardAutomatic" v-if="cardShowAutomatic">
                <v-row no-gutters>
                    <v-col cols="1" xs="0" sm="0" md="1" class="flex-grow-0 flex-shrink-0"></v-col>
                    <v-col cols="10" xs="0" sm="0" md="10" class="flex-grow-0 flex-shrink-0">
                        <br>
                        <v-row justify="center" no-gutters>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Fecha Inicio:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ initDate }}</v-list-item-title>
                                </v-row>
                            </v-col>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Saldo Bot:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ available }}</v-list-item-title>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <v-row justify="center" no-gutters>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Beneficios:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ profits }}</v-list-item-title>
                                </v-row>
                            </v-col>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Comisiones:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ fees }}</v-list-item-title>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br>
                        <v-divider></v-divider>
                        <v-row justify="center" no-gutters>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Trades Ganadores:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ tradesGanadores }}</v-list-item-title>
                                </v-row>
                            </v-col>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-list-item-title class="text-center">Trades Perdedores:</v-list-item-title>
                                    <v-list-item-title class="text-center">{{ tradesPerdedores }}</v-list-item-title>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <v-row v-show="isActive" no-gutters>
                            <v-col cols="4" xs="0" sm="0" md="4" class="flex-grow-0 flex-shrink-0"></v-col>
                            <v-col cols="4" xs="12" sm="12" md="4" class="flex-grow-0 flex-shrink-0">
                                <v-row no-gutters justify="center">
                                    <v-card>
                                        <v-btn :color="colors" @click="statusBot">{{ msgBtn }}</v-btn>
                                    </v-card>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br>
                    </v-col>
                </v-row>
            </slot>
            <!-- Inner card area where yuou can put tables/tabs or anything -->
            <slot :name="cardInner" v-if="cardShowInner">
                <!-- <MaterialfyDataChart ref="dataChart"/> -->
                <!-- <v-card-text class="text-h5 font-weight-bold">
                    This is a bunch of text since i couldnt think of anything to fill
                    up the default content of this card. fix with pull request lol
                </v-card-text> -->
            </slot>

            <v-card-actions>
                <slot :name="cardActions" v-if="cardShowActions"> </slot>
            </v-card-actions>
        </v-container>
    </v-card>
</template>

<script>
import UserService from '@/services/user.service'

export default {
    name: 'MaterialfyBasicCard',
    props: {
        cardMinHeight: {
            default: '100',
        },
        cardMinWidth: {
            default: '300',
        },
        cardMaxWidth: {
            default: '600',
        },
        cardTitle: {
            default: 'Materialfy Basic Card',
        },
        cardSubHeaderText: {
            default: 'Subheader',
        },
        cardIcon: {
            default: 'crdIcon',
        },
        cardInner: {
            default: 'crdInner',
        },
        cardActions: {
            default: 'crdActions',
        },
        cardHeaderColor: {
            default: 'tertiary',
        },
        cardColor: {
            default: 'primary',
        },
        cardAvatar: {
            default: 'crdAvatar',
        },
        cardAutomatic: {
            default: 'crdAutomatic',
        },
        isDark: {
            default: false,
        },
        cardShowDivider: {
            default: true,
        },
        cardShowActions: {
            default: true,
        },
        cardShowInner: {
            default: true,
        },
        cardShowAvatar: {
            default: true,
        },
        cardShowTitle: {
            default: true,
        },
        cardShowSubHeader: {
            default: true,
        },
        cardShowAutomatic: {
            default: true,
        },
        data: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            interval: {},
            value: 0,
            colors: 'success',
            msgBtn: '',
            isAdmin: '',
            isAutomatic: false,

            titleOrders: '',
            pair1: '',
            pair2: '',
            initDate: '',
            available: '',
            market1: '',
            startPrice: '',
            currentPrice: '',
            profits: '',
            fees: '',
            tradesGanadores: '',
            tradesPerdedores: '',
            right: null,
            start: false,
            isOpenDialog: false,
            isActive: true,
            isLoaded: false,
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    mounted() {
        this.interval = setInterval(() => {
            if (this.value === 100) {
                return (this.value = 0)
            }
            this.value += 10
        }, 1000)
        // console.log(this.data)
        this.initData(this.data.id, false, this.data.active)
    },
    methods: {
        initData(value, isAdmin, isActive) {
            this.idBot = value
            this.isAdmin = isAdmin
            this.isActive = isActive
            UserService.getStatusBot(this.idBot).then(
                response => {
                    
                    if (response.data === 'NOT INIT') {
                        UserService.getBot(this.idBot).then(
                            response => {
                                this.bot = response.data
                                this.isAutomatic = this.bot.automatico
                                this.start = false
                                this.msgBtn = 'START'
                                this.colors = 'success'
                            }
                        );
                    } else {
                        // console.log(response.data)
                        this.loadData(response.data, isAdmin);
                    }
                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        loadData(data) {
            // console.log(data)

            if (data !== 'NOT INIT') {
                // console.log(data.bot.pair)
                this.bot = data[0].bot
                this.isAutomatic = this.bot.automatico

                // this.$refs.chart.chartOptions.xaxis.categories = ['Enero', 'Febrero', 'Marzo', 'Abril',
                //     'Mayo', 'Junio', 'Julio', 'Agosto',
                //     'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

                // 
                // this.$refs.chart.loadDataSets(this.bot.id, isAdmin)
                // this.loadUserChart(this.idBot)
                // this.$refs.dataChart.loadUserChart(this.bot.id, 2025)

                // console.log(data[0])
                this.titleOrders = this.bot.pair;
                let arrayPairs = this.bot.pair.split('-');
                this.pair1 = arrayPairs[0];
                this.pair2 = arrayPairs[1];
                this.initDate = data[0].start_time
                this.available = data[0].available
                this.market1 = data[0].market1_balance
                this.startPrice = data[0].start_price
                this.currentPrice = data[0].currentPrice
                this.fees = data[0].fees
                this.profits = data[0].profits
                this.tradesGanadores = data[0].ganadoras
                this.tradesPerdedores = data[0].perdedoras
                

                if (this.bot.started === false) {
                    this.start = false
                    this.msgBtn = 'START'
                    this.colors = 'success'

                } else {
                    this.start = true
                    this.msgBtn = 'STOP'
                    this.colors = 'error'
                }
            } else {
                this.start = false
                this.msgBtn = 'START'
                this.colors = 'success'
            }
        },
        statusBot(item, action) {
            this.$emit('action-clicked', { item, action });
        },
    }
}
</script>

<style scoped>
.v-progress-circular {
    margin: 1rem;
}

.innercardheight {
    height: 100px;
}
</style>
